import {createFileRoute} from "@tanstack/react-router";
import {useWalletNftsQuery} from "@/api/endpoints/wallet";
import {clsx} from "@/utils/clsx";
import styles from "./index.module.scss";
import {Title} from "@/components/ui/Title/Title";
import {useMemo} from "react";
import {useTranslation} from "react-i18next";

export const Route = createFileRoute("/_mainLayout/balance/")({
  component: RouteComponent,
});

function RouteComponent() {
  const {t} = useTranslation("balance");
  const {data} = useWalletNftsQuery();

  const items = useMemo(
    () =>
      data?.map((item) => {
        return {
          name: item?.metadata?.name,
          description: item?.metadata?.description,
          imageSrc: item?.metadata?.image,
        };
      }) || [],
    [data],
  );
  return (
    <div className={clsx(styles.root, styles.balance)}>
      <Title variant="white" size="regular">
        {t("title")}
      </Title>
      <div className={styles.list}>
        {items?.map((item) => (
          <div key={item.name} className={clsx(styles.item)}>
            <img src={item.imageSrc} alt={item.name} className={styles.image}/>

            <div className={styles.wrapper}>
              <div className={styles.name}>{item.name}</div>
              <div className={styles.description}>{item.description}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
